import { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

import {
  Button,
  Row,
  Col,
  Drawer,
  Input,
  Space,
  DatePicker,
  Divider,
  Upload,
  Table,
  notification,
  Modal,
  Tag,
  Tooltip,
  Collapse,
} from "antd";
import {
  CloseCircleOutlined,
  SearchOutlined,
  LinkOutlined,
  UploadOutlined,
  EditOutlined,
  PlusOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import ExportButton from "../ExportButton";
import Highlighter from "react-highlight-words";
const { RangePicker } = DatePicker;

const VoucherCard = styled.div`
  margin: 15px;
  background: #e8e9f3;
  border-radius: 15px;
  padding: 30px;

  .voucher-btn,
  .ant-btn {
    border: 1px solid #494d7d !important;
    color: #494d7d !important;
    height: 45px !important;
    background: transparent !important;
    width: 100% !important;
    display: flex;
    align-iems: center;
    justify-content: center;
  }

  h5 {
    font-size: 20px !important;
    margin-bottom: 0;
  }

  .inputDados .ant-select-selection-item {
    color: #494d7d !important;
  }

  .inputDados.ant-select-disabled,
  .inputDados.ant-select-outlined.ant-select-disabled:not(
      .ant-select-customize-input
    )
    .ant-select-selector {
    background: #fff !important;
  }

  .apply-code-btn {
    border-radius: 12px;
    padding-left: 30px;
    padding-right: 30px;
  }

  .input-voucher,
  .input-voucher .ant-input,
  .input-voucher ::placeholder {
    background: #494d7d !important;
    border: 1px solid #494d7d !important;
    color: #fff !important;
  }

  ::placeholder {
    color: #fff !important;
    opacity: 1 !important; /* Firefox */
  }

  .apply-code-btn,
  .inputCode {
    border: 1px solid #494d7d !important;
    color: #494d7d;
    height: 35px;
  }

  .inputDados {
    border: 1px solid #dfdfe4 !important;
    color: #494d7d;
    height: 45px !important;
    line-height: 45px;
    width: 100%;
  }

  .inputDados .ant-select-selector {
    border: 1px solid #dfdfe4 !important;
    color: #494d7d;
    min-height: 45px !important;
    width: 100%;
    height: auto !important;
  }

  .total {
    font-size: 20px;
    text-transform: uppercase;
    font-weight: bold;
  }

  h6 {
    font-size: 16px;
  }

  .subtitle {
    font-size: 17px;
  }

  .view-btn {
    color: #fff;
    background: #494d7d;
    padding: 10px 30px;
    border-radius: 5px;
    text-decoration: none !important;
    margin-top: 20px;
  }

  .view-more {
    text-decoration: underline;
  }

  .delete-icon {
    font-size: 15px;
  }

  .margin-vertical-auto {
    margin: auto 0;
  }

  .next-btn,
  .next-btn span {
    background: #494d7d !important;
    color: #ffffff !important;
  }

  .pre-btn,
  .pre-btn span {
    background: #ffffff !important;
    color: #494d7d !important;
  }

  .ant-input-suffix {
    background: #494d7d !important;
    color: #fff !important;
  }

  .next-btn,
  pre-btn {
    height: auto !important;
  }

  .mb-20 {
    margin-bottom: 20px;
  }

  .rangePicker {
    height: 45px;
    border: 1px solid #dfdfe4 !important;
    width: 100%;
  }

  .ant-input-disabled,
  .ant-select-disabled,
  .ant-picker-disabled {
    background: #fff !important;
  }

  .ant-select {
    min-height: 45px !important;
    height: auto !important;
  }

  .ant-picker-input input {
    color: #494d7d !important;
  }

  .voucher-manage {
    padding: 0 !important;
    background: #fff !important;
  }
`;

const ManageVoucher = styled.div`
  .voucher-btn,
  .ant-btn {
    border: 1px solid #494d7d !important;
    color: #494d7d !important;
    height: 45px !important;
    background: transparent !important;
    width: 100% !important;
    display: flex;
    align-iems: center;
    justify-content: center;
  }

  .ant-collapse-header-text {
    font-weight: bold;
  }

  .ant-collapse-content-box p:last-child {
    margin-bottom: 0;
  }

  .upload-file-div {
    margin-top: 0px;
  }

  .text-right {
    text-align: right;
  }

  .anexar-title {
    font-size: 14px;
    color: #494d7d;
    margin-bottom: 0;
  }

  .anexar-subtitle {
    font-size: 10px;
    color: #809fb8;
    margin-bottom: 0;
  }

  .ant-upload-select {
    width: 100%;
  }

  .btn-upload
    .ant-upload-list-item-actions
    .ant-upload-list-item-action.ant-btn {
    border: none !important;
  }

  * {
    color: #494d7d;
  }

  .label-pago {
    background: #ddffdd;
    border-radius: 6px;
    padding: 4px 10px;
  }
  .label-nao-pago {
    background: #ffdddd;
    border-radius: 6px;
    padding: 4px 10px;
  }

  h5 {
    font-size: 20px !important;
    margin-bottom: 0;
  }

  .apply-code-btn {
    border-radius: 12px;
    padding-left: 30px;
    padding-right: 30px;
  }

  .input-voucher,
  .input-voucher .ant-input,
  .input-voucher.ant-input-affix-wrapper,
  .input-voucher input::placeholder {
    background: #494d7d !important;
    border: 1px solid #494d7d !important;
    color: #fff !important;
  }

  ::placeholder {
    color: #fff !important;
    opacity: 1 !important; /* Firefox */
  }

  .apply-code-btn,
  .inputCode {
    border: 1px solid #494d7d !important;
    color: #494d7d;
    height: 35px;
  }

  .inputDados .ant-select {
    height: 45px;
  }
  .inputDados:not(.ant-select) {
    border: 1px solid #dfdfe4 !important;
    color: #494d7d;
    height: 45px !important;
    width: 100%;
  }

  .inputDados .ant-select-selector {
    border: 1px solid #dfdfe4 !important;
    color: #494d7d;
    min-height: 45px !important;
    width: 100%;
    height: auto !important;
  }

  .inputDados .ant-select-selection-placeholder {
    line-height: 35px !important;
    height: 45px !important;
  }

  .total {
    font-size: 20px;
    text-transform: uppercase;
    font-weight: bold;
  }

  h6 {
    font-size: 16px;
  }

  .subtitle {
    font-size: 17px;
  }

  .view-btn {
    color: #fff;
    background: #494d7d;
    padding: 10px 30px;
    border-radius: 5px;
    text-decoration: none !important;
    margin-top: 20px;
  }

  .view-more {
    text-decoration: underline;
  }

  .delete-icon {
    font-size: 15px;
  }

  .margin-vertical-auto {
    margin: auto 0;
  }

  .next-btn,
  .next-btn span {
    background: #494d7d !important;
    color: #ffffff !important;
  }

  .pre-btn,
  .pre-btn span {
    background: #ffffff !important;
    color: #494d7d !important;
  }

  .ant-input-suffix {
    background: #494d7d !important;
    color: #fff !important;
  }

  .next-btn,
  pre-btn {
    height: auto !important;
  }

  .mb-20 {
    margin-bottom: 20px;
  }

  .rangePicker {
    height: 45px;
    border: 1px solid #dfdfe4 !important;
    width: 100%;
  }

  .voucher-manage {
    padding: 0 !important;
    background: #fff !important;
  }

  .inputDados .ant-input-number-input-wrap input {
    height: 45px !important;
  }
`;

export default function DrawerCasosRespostas(props) {
  const session_storage = JSON.parse(localStorage.getItem("session_data"));
  const [openDrawer, setOpenDrawer] = useState(false);
  const [dataToShow, setDataToShow] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [respostas1, setRespostas1] = useState([]);
  const [respostas2, setRespostas2] = useState([]);
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });


  useEffect(() => {
    setOpenDrawer(props.show);
    setDataToShow([]);
    if (props.show) {
      if (props.respostas?.length == 0) {
        setIsEmpty(true);
        return;
      }
      handleCasoRespostas(props.respostas);
    }
  }, [props]);



  const formatarTempo = (totalSegundos) => {
    const minutos = Math.floor(Number(totalSegundos) / 60);
    const segundos = totalSegundos % 60;
    return `${String(minutos).padStart(2, '0')} min ${String(segundos).padStart(2, '0')} seg`;
  };

  const handleCasoRespostas = (allRespostas) => {

    if (allRespostas.length == 0) {
      setIsEmpty(true);
      setDataToShow([]);
      return;
    }

    let myRespostas = [];


    let respostasCount = JSON.parse(props.caso.respostas);

    let countRespostas = 0;

    respostasCount = respostasCount?.map((resposta) => {
      const countThis = allRespostas.filter((resp) => resp.resposta === resposta.texto).length;
      countRespostas += countThis;
      return {
        ...resposta,
        count: countThis,
      };
    });

    respostasCount = respostasCount?.map((resposta) => {
      const perc = countRespostas === 0 ? 0 : Number((resposta.count / countRespostas) * 100) + '%' + ' (' + resposta.count + '/' + countRespostas + ')';
      return {
        ...resposta,
        perc,
      };
    });

    setRespostas1(respostasCount);

    if (props.caso.questao_2) {
      let respostas2Count = JSON.parse(props.caso.respostas_2);

      let count2Respostas = 0;

      respostas2Count = respostas2Count?.map((resposta) => {
        const countThis = allRespostas.filter((resp) => resp.resposta_2 === resposta.texto).length;
        count2Respostas += countThis;
        return {
          ...resposta,
          count: countThis,
        };
      });
      

      respostas2Count = respostas2Count?.map((resposta) => {
        const perc = countRespostas === 0 ? 0 : Number((resposta.count / count2Respostas) * 100) + '%' + ' (' + resposta.count + '/' + count2Respostas + ')';
        return {
          ...resposta,
          perc,
        };
      });
      
      setRespostas2(respostas2Count);
    }



    allRespostas.map((resposta) => {
      resposta.user_name = resposta.user.name;
      resposta.user_email = resposta.user.email;
      if (resposta.user.apelido) {
        resposta.user_name = resposta.user_name + ' ' + resposta.user.apelido;
      }
      resposta.novotempo = formatarTempo(Number(resposta?.tempo));
      resposta.createdAt = formatarData(resposta.created_at);
      resposta.resposta1 = (resposta.resposta_correta == 1) ? 
      <>
        <Tooltip placement="top" title={resposta.resposta}>
          <Tag color="green">Resposta Correta</Tag>
        </Tooltip>
      </> 
      : 
      <>
        <Tooltip placement="top" title={resposta.resposta}>
          <Tag color="red">Resposta errada</Tag>
        </Tooltip>
      </>;
      resposta.resposta2 = (resposta.resposta_correta_2 == 1) ? 
      <>
        <Tooltip placement="top" title={resposta.resposta_2}>
          <Tag color="green">Resposta Correta</Tag>
        </Tooltip>
      </> 
      : 
      <>
        <Tooltip placement="top" title={resposta.resposta_2}>
          <Tag color="red">Resposta errada</Tag>
        </Tooltip>
      </>;
    });

    setDataToShow(allRespostas);
  };

  // useEffect(() => {
  //   if (props.events.length > 0) {
  //     let eventsToShow = [];
  //     props.events.map((event) => {
  //       eventsToShow.push({ value: event.id, label: event.titulo });
  //     });

  //     setOptionsEvents(eventsToShow);
  //   }
  // }, [props.events]);

  const handleSearchClear = () => {
    setValueSearch("");
  };

  const onCloseDrawer = () => {
    props.onChange(false);
  };

  const onUpdate = (purchases) => {
    props.onUpdate(purchases);
  };

  const mainColumns = [
    {
      title: "Nome",
      dataIndex: "user_name",
      key: "nome",
      ...getColumnSearchProps("billing_name"),
    },
    {
      title: "Email",
      dataIndex: "user_email",
      key: "email",
      ...getColumnSearchProps("email"),
    },
    {
      title: "Pergunta 1",
      dataIndex: "resposta1",
    },
    {
      title: "Tempo",
      dataIndex: "novotempo",
    },
    {
      title: "Data",
      dataIndex: "createdAt",
    },
  ];


  const main2Columns = [
    {
      title: "Nome",
      dataIndex: "user_name",
      key: "nome",
      ...getColumnSearchProps("billing_name"),
    },
    {
      title: "Email",
      dataIndex: "user_email",
      key: "email",
      ...getColumnSearchProps("email"),
    },
    {
      title: "Pergunta 1",
      dataIndex: "resposta1",
    },
    {
      title: "Pergunta 2",
      dataIndex: "resposta2",
    },
    {
      title: "Tempo",
      dataIndex: "novotempo",
    },
    {
      title: "Data",
      dataIndex: "createdAt",
    },
  ];

  notification.config({
    placement: "bottomRight",
    bottom: 10,
    duration: 5,
    rtl: false,
  });

  const formatarData = (dataString) => {
    const data = new Date(dataString);

    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();

    const horas = String(data.getHours()).padStart(2, '0');
    const minutos = String(data.getMinutes()).padStart(2, '0');

    return `${dia}-${mes}-${ano} ${horas}:${minutos}`;
  };

  function formatarMesAno(data) {
  
    if (!data) {
      return;
    }
    const [mes, ano] = data?.split("/");


    const nomesMeses = [
      "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
      "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
    ];

    const mesIndex = parseInt(mes, 10) - 1; // meses começam do 0
    const nomeMes = nomesMeses[mesIndex] || "Mês inválido";

    return `${nomeMes} ${ano}`;
  }

  const items = [
    {
      key: '1',
      label: 'Questão 1 - ' + props.caso?.questao,
      children: <>
      { respostas1.map((resp) => {
        return (
          <>
            { resp.resposta == false && 
              <p>{resp.texto}&nbsp;&nbsp;&nbsp;<Tag color="red">{resp.perc}</Tag></p>
            }
            { resp.resposta == true && 
              <p>{resp.texto}&nbsp;&nbsp;&nbsp;<Tag color="green">{resp.perc}</Tag> </p>
            }
          </>
        );
      })}
      </>
    },
    {
      key: '2',
      label: 'Questão 2 - ' + props.caso?.questao_2,
      children: <>
      { respostas2.map((resp) => {
        return (
          <>
            { resp.resposta == false && 
              <p>{resp.texto}&nbsp;&nbsp;&nbsp;<Tag color="red">{resp.perc}</Tag></p>
            }
            { resp.resposta == true && 
              <p>{resp.texto}&nbsp;&nbsp;&nbsp;<Tag color="green">{resp.perc}</Tag> </p>
            }
          </>
        );
      })}
      </>
    },
  ];

  const item = [
    {
      key: '1',
      label: 'Questão 1 - ' + props.caso?.questao,
      children: <>
      { respostas1.map((resp) => {
        return (
          <>
            { resp.resposta == false && 
              <p>{resp.texto}&nbsp;&nbsp;&nbsp;<Tag color="red">{resp.perc}</Tag></p>
            }
            { resp.resposta == true && 
              <p>{resp.texto}&nbsp;&nbsp;&nbsp;<Tag color="green">{resp.perc}</Tag> </p>
            }
          </>
        );
      })}
      </>
    }
  ];

  return (
    <>
      <Drawer
        title={"Respostas ao Caso do mês de " + formatarMesAno(props?.caso?.agendar_post)}
        key={"eventUsers" + props?.caso?.id}
        width={1200}
        onClose={onCloseDrawer}
        open={openDrawer}
        destroyOnClose={false}
        extra={
          <Space>
            <Button
              onClick={() => {
                setOpenDrawer(false);
              }}
            >
              Fechar
            </Button>
          </Space>
        }
      > 
        <ManageVoucher>
          <Collapse items={props?.caso?.questao_2 ? items : item}  className="mb-10"/>
          <Table
            columns={props?.caso?.questao_2 ? main2Columns : mainColumns}
            // onRow={(record, index) => ({
            //   style: {
            //     background: record.quotasNaoPagas > 0 ? "#ffdddd" : "#ddffdd",
            //   },
            // })}
            // rowClassName={(record, index) =>
            //   record.quotasNaoPagas > 0 ? "table-danger" : "table-success"
            // }
            dataSource={dataToShow}
            loading={!dataToShow}
            // pagination={{ pageSize: tablePagination }}
          />
          <Divider />
        </ManageVoucher>
      </Drawer>
    </>
  );
}
